import { handleActions } from "redux-actions";
import { WORKING_ORDER } from "constants/action-types";
import type { ICompany } from "components/contacts/contacts-types";

export interface IWorkingCompanyState {
    payload: ICompany | null | undefined;
    meta?: any;
}

export const company = handleActions<IWorkingCompanyState>(
    { [WORKING_ORDER.COMPANY.SET]: (state, { payload, meta }) => ({ ...state, payload, meta }) } as any,
    { payload: undefined }
);
